import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document_transparent",
  "use": "icon-document_transparent-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-document_transparent\">\n  <path d=\"M6 3V29H26V9.59375L25.7188 9.28125L19.7188 3.28125L19.4062 3H6ZM8 5H18V11H24V27H8V5ZM20 6.4375L22.5625 9H20V6.4375ZM11 13V15H21V13H11ZM11 17V19H21V17H11ZM11 21V23H21V21H11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol